module.exports = __webpack_public_path__ + "img/news3-1.5fb17996.jpeg";